import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';

import { Observable, Subscription, combineLatest } from 'rxjs';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';

import { LayoutService } from 'src/app/_metronic/layout';
import {
  MenuComponent,
  DrawerComponent,
  ToggleComponent,
  ScrollComponent,
} from '../../../kt/components';
import { AccountsContextService } from 'src/app/accounts/account-context.service';
import { PatronAclService } from './patron/patron-acl.service';
import { AccountsService } from 'src/app/accounts/accounts.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit, OnDestroy {
  @ViewChild('ktAsideScroll', { static: true })
  public ktAsideScroll: ElementRef;

  @ViewChild('kt_account_menu', { static: false, read: ElementRef })
  public ktAccountMenu: ElementRef;

  public asideTheme: string = '';
  public asideMinimize: boolean = false;
  public asideMenuCSSClasses: string = '';

  public readonly patronAclService: PatronAclService;
  public readonly router: Router;
  public readonly whiteLabelService: WhiteLabelService;

  private unsubscribe: Subscription[] = [];
  private accountsService: AccountsService;

  private readonly layout: LayoutService;
  private readonly contextService: AccountsContextService;

  constructor() {
    this.accountsService = inject(AccountsService);
    this.patronAclService = inject(PatronAclService);
    this.router = inject(Router);
    this.whiteLabelService = inject(WhiteLabelService);
    this.layout = inject(LayoutService);
    this.contextService = inject(AccountsContextService);
  }

  public get homeRedirectRoute$() {return this.contextService.homeRedirectRoute$};

  public get account$() {return this.contextService.account$};

  public get showAccountsDropdown$(): Observable<boolean> {
    return combineLatest([
      this.accountsService.advertisers$,
      this.accountsService.publishers$,
    ])
      .pipe(
        map(([advertisers, publishers]) => 
          !this.whiteLabelService.isWhiteLabel
          || ((advertisers.length > 0 && publishers.length > 0) || advertisers.length > 1 || publishers.length > 1)),
      );
  }

  public ngOnInit(): void {
    this.asideTheme = this.layout.getProp('aside.theme') as string;
    this.asideMinimize = this.layout.getProp('aside.minimize') as boolean;
    this.asideMenuCSSClasses = this.layout.getStringCSSClasses('asideMenu');

    this.routingChanges();
  }

  /**
   * @deprecated ToDo: change logic of logo click redirect to a more predictable solution
   */
  public routingChanges() {
    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.menuReinitialization();
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  public menuReinitialization(): void {
    setTimeout(() => {
      MenuComponent.reinitialization();
      DrawerComponent.reinitialization();
      ToggleComponent.reinitialization();
      ScrollComponent.reinitialization();
      if (this.ktAsideScroll && this.ktAsideScroll.nativeElement) {
        this.ktAsideScroll.nativeElement.scrollTop = 0;
      }
    }, 50);
  }

  public ngOnDestroy(): void {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }
}
